import React from "react";
import Image from "next/image";
export default function MemberShort({ data }) {
  return (
    <div className="flex flex-col items-start justify-start gap-3 w-full">
      <div className="relative w-[300px] h-[230px] rounded-xl overflow-hidden shrink-0">
        <Image
          src={data?.image}
          alt={data.name}
          fill
          className="object-cover object-[50%_20%] w-full"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 479px, (max-width: 1200px) 479px,(max-width: 1920px) 479px, 479px "
        />
      </div>
      <div className="flex flex-col w-full gap-2">
        <p className="text-darkBlue font-bold md:text-xl text-base">
          {data?.name}
        </p>
        <div className="md:text-base text-sm text-justify">
          {data?.description}
        </div>
      </div>
    </div>
  );
}
